import * as React from 'react';
import ReactDOM from 'react-dom';

import { Session } from './Session.js';
import { Config } from '../Config.js';

import { LogoutConfirm } from '../LogoutConfirm.js';
import { DettaglioCliente } from '../DettaglioCliente.js';

const sessione = new Session();
const config = new Config();

export class Utils {
    
    constructor()
    {
        this.mesi = {
            'GENNAIO' : '1',
            'FEBBRAIO' : '2',
            'MARZO' : '3',
            'APRILE' : '4',
            'MAGGIO' : '5',
            'GIUGNO' : '6',
            'LUGLIO' : '7',
            'AGOSTO' : '8',
            'SETTEMBRE' : '9',
            'OTTOBRE' : '10',
            'NOVEMBRE' : '11',
            'DICEMBRE' : '12'
        };
    }
    
    getBoolDatainfoDueLivelli( tipo , campo , campoDefault ){
        var datainfo = sessione.get('datainfo');

        if( datainfo !== null && tipo in datainfo ){
            if( datainfo[tipo] !== null && campo in datainfo[tipo] ){ 
                if( datainfo[tipo][campo] !== false ){ return true; } 
                else { return false;}
            }
        }
        return campoDefault;
    }
    
    /** qui controlla solo il campo VISUALIZZA **/
    getInfoSocieta( campo , campoDefault ){   
        var datainfosoc = sessione.get('datainfosocieta');

        if( datainfosoc !== null && campo in datainfosoc ){
            
            if( datainfosoc[campo] !== null && this.isObjectFull(datainfosoc[campo])===true ){     
                if( 'VISUALIZZA' in datainfosoc[campo]){ 
                    if( datainfosoc[campo].VISUALIZZA === '1' || datainfosoc[campo].VISUALIZZA === 1 ) return true;
                    else return false;
                }
            }
            else if( datainfosoc[campo] !== null && this.isObjectFull(datainfosoc[campo]) === false){

                // gestione da MS381_AC2_CUSTOMIZATION
                if( datainfosoc[campo] === 'SI' ){ return true;} else { return false; }
            }
            else { return false;}
        }
        return campoDefault;
    }
    
    /** qui restituisce TUTTO L'OGGETTO **/
    getObjInfoSocieta( campo , campoDefault ){   
        var datainfosoc = sessione.get('datainfosocieta');

        if( datainfosoc !== null && campo in datainfosoc ){
            if( datainfosoc[campo] !== false ){ return datainfosoc[campo]; } 
            else { return false;}
        }
        return campoDefault;
    }
    
    /** ATTENZIONE !! questa funzione con AGGREGATI e AMMINISTRATORI estrae solo i menu --> USARE leggiInfoCliente **/
    /** 2020-01-30 --> usata solo in getMenuUser qualche riga più sotto **/
    // esempio datainfo.menu.fatture
    getInfoUser( campo , innerarray, campoDefault ){   
        var datainfo = sessione.get('datainfo');

        if( datainfo !== null && innerarray in datainfo ){
        
            if( datainfo[innerarray] !== null && campo in datainfo[innerarray] ){
            
                if( datainfo[innerarray][campo] === true || datainfo[innerarray][campo] === 1 ){ return true; }
                else { return false; }
            }
        }
        return campoDefault;
    }

    
    /** ATTENZIONE !! questa funzione con AGGREGATI e AMMINISTRATORI estrae solo i menu --> USARE leggiInfoCliente **/
    /** 2020-01-30 --> non usata in alun punto **/
    // recupero il valore esatto
    getObjUser( campo , innerarray, campoDefault ){   
        var datainfo = sessione.get('datainfo');

        if( datainfo !== null && innerarray in datainfo ){
        
            if( datainfo[innerarray] !== null && campo in datainfo[innerarray] ){
            
                if( datainfo[innerarray][campo] !== false ){ 
                    console.log( campo , datainfo[innerarray][campo] );
                    return datainfo[innerarray][campo];
                }
            }
        }
        return campoDefault;
    }
    
    
    leggiInfoCliente( campo , campoDefault){
        let datiutente = sessione.get('datiutente');
        
        if( datiutente !== null && campo in datiutente ){
            if( datiutente[campo] !== null ){
                return datiutente[campo];
            }
        }
        
        return campoDefault;
    }
    
    
    
    getMenuUser( campo, campoDefault ){
        return this.getInfoUser( campo , 'menu', campoDefault );
    }
    
    
    _onFormatDate (date: Date) {
        // return date.getDate() + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear() % 100);
        var d = date.getDate().toString();
        var m = (date.getMonth() + 1).toString();
        var y = date.getFullYear().toString();
        
        if(d.length < 2){ d = '0'+d; }
        if(m.length < 2){ m = '0'+m; }

        return d + '/' + m + '/' + y;
    }
    
    leggiImpostazioniPersonali() {
        // parto con un default vuoto, in modo che almeno esista !!!
        sessione.set('datainfo' , {} );

        let request = new Request( config.get("customers_configurazioni") ,{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({ id_cliente: sessione.get('id_cliente') })
        });

        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            if (result.success) {
                sessione.set('datainfo' , result.data );
            }
        }).catch(error => {
            throw(error);
        })
    }
    
    controllaParametri( conta ){
        setTimeout( function(){
            var datainfosocieta = sessione.get('datainfosocieta');
            
            if( datainfosocieta===null || !('LOGIN_PRIVACY' in datainfosocieta ) )
            {
                if(conta++ < 200 ){ this.controllaParametri(conta); }
            }
            else
            {
                console.log(datainfosocieta);

                if( datainfosocieta !== null && 'LOGIN_PRIVACY' in datainfosocieta )
                {
                    if(datainfosocieta.LOGIN_PRIVACY !== '' && datainfosocieta.LOGIN_PRIVACY !== null ){
                        
                        this.state['showLOGIN_PRIVACY'] = '';
                        this.state['textLOGIN_PRIVACY'] = '';
                        this.state['buttonDisabled'] = false;
                        
                        this.setState({ showLOGIN_PRIVACY:'visualizza divprivacy' , textLOGIN_PRIVACY: datainfosocieta.LOGIN_PRIVACY , buttonDisabled:true } );
                    }
                }
                
                /* ticket #51976 del 28.98.2020 */
                if( datainfosocieta !== null && 'MESSAGGIO_LOGIN' in datainfosocieta )
                {
                    if(datainfosocieta.MESSAGGIO_LOGIN !== '' && datainfosocieta.MESSAGGIO_LOGIN !== null ){
                        
                        this.state['showMESSAGGIO_LOGIN'] = '';
                        this.state['textMESSAGGIO_LOGIN'] = '';
                        
                        this.setState({ showMESSAGGIO_LOGIN:'visualizza centrato divmessaggiologin' , textMESSAGGIO_LOGIN: datainfosocieta.MESSAGGIO_LOGIN } );
                    }
                }
                
                if( datainfosocieta !== null && 'BTN_PRIMO_ACCESSO' in datainfosocieta )
                {
                    if(datainfosocieta.BTN_PRIMO_ACCESSO !== '' && datainfosocieta.BTN_PRIMO_ACCESSO !== null  ){
                        this.state['textREGISTRATI'] = '';
                        this.setState({ textREGISTRATI:datainfosocieta.BTN_PRIMO_ACCESSO } );
                    }
                }
                
                // BOTTONE RECUPERA PASSWORD su LoginWindow.js
                if( datainfosocieta !== null && 'RESET_PWD_AREA_CLIENTI' in datainfosocieta )
                {
                    if(datainfosocieta.RESET_PWD_AREA_CLIENTI === 'SI' ){
                        this.state['mostraBottoneRecupera'] = '';
                        this.setState({ mostraBottoneRecupera:'' } );
                    }
                    else
                    {
                        this.state['mostraBottoneRecupera'] = '';
                        this.setState({ mostraBottoneRecupera:'nascosto' } );
                    }
                } else {
                    this.state['mostraBottoneRecupera'] = '';
                    this.setState({ mostraBottoneRecupera:'nascosto' } );
                }
                

                return false;
            }
        }.bind(this),50);
    }
    
    
    estraiDatiModificati( datinuovi , datiOriginali ){
        if( typeof(datiOriginali)==='object' && Object.keys(datiOriginali).length === 0 ){return datinuovi;}
        if( Array.isArray(datiOriginali)===true && datiOriginali.length === 0 ){return datinuovi;}
        
        var datiModificati = {};
        
        for ( let campo in datinuovi ) {
            
            if( typeof(datiOriginali)==='object' && (campo in datiOriginali) )
            {
                var originale = datiOriginali[campo];
                var nuovo = datinuovi[campo];
                
                if( originale !== nuovo ) { datiModificati[campo] = nuovo; }
            }
            if( typeof(datiOriginali)==='object' && !(campo in datiOriginali) )
            {
                datiModificati[campo] = datinuovi[campo];
            }
        }
        
        return datiModificati;
    }

    isObjectFull( obj ){
        if( typeof(obj)!=='object' ){ return false;}
        if( Object.keys(obj).length === 0 ){ return false;}
        if( Object.keys(obj).length !== 0 ){ return true;}
        
        return true;
    }
    
    isArrayFull( obj ){
        if( Array.isArray(obj) === false ){ return false;}
        if( obj.length === 0 ){ return false;}
        if( obj.length !== 0 ){ return true;}
        
        return true;
    }
    
    periodoShort(txt){
        for( let m in this.mesi ){txt = txt.replace( m , this.mesi[m]+'-');}
        txt = txt.split(" ").join("");
        return txt;
    }
    
    vaiAId( id ){
        document.getElementById( id ).scrollIntoView();
    }

    dialogLogout(){
        // console.log("Qui dovrei aprire la dialog box x il Logout");
        ReactDOM.unmountComponentAtNode(document.getElementById('dialogcontainer'));
        ReactDOM.render(<LogoutConfirm />, document.getElementById('dialogcontainer'));
    }
    

    logout(){
        fetch(config.getLogout(),{credentials: "include"}).then(function(response){
            return response.json();
        }).then(function(result){
           if (result.success){
               
                let location = this.getObjInfoSocieta( 'AC_HOMEURL' , false );

                sessione.clear();
               
                if( '' === location || false === location ){ 
                    /*  window.location ==>
                        host: "clientisviluppo.enerp.biz"
                        hostname: "clientisviluppo.enerp.biz"
                        href: "https://clientisviluppo.enerp.biz/AC2/build/?auth=RP!UTmnbcvbsdjhbsdjkb,bmnbbjhjksdsd"
                        origin: "https://clientisviluppo.enerp.biz"
                        pathname: "/AC2/build/"
                    */
                   // window.location.reload();
                   window.location = window.location.origin + window.location.pathname;
                }
                else { window.location = location; }
           } 
        }.bind(this) );
    }
    
    gestisciMessaggio( result ){
        if( 'message' in result )
        {
            // sessione scaduta, devo disconnettere l'utente
            if( result.message === "Sessione Scaduta/Id Cliente non valido"){
                sessione.set('maschera' , null);
                console.log("intercettata sessione scaduta");
                this.logout();
            }
        }
    }
    
    ordinaArrayByKey( arr , key ){
        return arr.sort((a, b) => { 
            var nameA = a[key].toUpperCase(); // ignora maiuscole e minuscole
            var nameB = b[key].toUpperCase(); // ignora maiuscole e minuscole
            if (nameA < nameB) { return -1; }
            if (nameA > nameB) { return 1; }
            return 0; // i nomi devono essere uguali
        });
    }
    
    inviaAutoletture( objPostData ){
        sessione.set('risulatoautoletture' ,false);
        
        let request = new Request( config.get("utility_inviaAutoletture"),{
            method: 'POST', mode: 'cors', credentials: "include",
            body: JSON.stringify(objPostData)
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            sessione.set('risulatoautoletture' ,result );
        }) 
    }

    inviaPrivacy( objPostData ){
        sessione.set('risulatoprivacy' ,false);
        
        let request = new Request( config.get("utility_inviaPrivacy"),{
            method: 'POST', mode: 'cors', credentials: "include",
            body: JSON.stringify(objPostData)
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            sessione.set('risulatoprivacy' ,result );
        }) 
    }


    leggiRisultatoPrivacy(){
        return sessione.get('risulatoprivacy');
    }
    
    leggiRisultatoAutoletture(){
        return sessione.get('risulatoautoletture');
    }
    
    ottieniUltimoMesePrec(dt){
        let pz = dt.split('/');
        
        let d = pz[0];
        let m = pz[1];
        let y = pz[2];
        
        let day = new Date(y, m-1, 0, 0, 0, 0, 0);
        
        d = day.getDate().toString();
        m = (day.getMonth() + 1).toString();
        y = day.getFullYear().toString();

        if(d.length < 2){ d = '0'+d; }
        if(m.length < 2){ m = '0'+m; }
        
        return d+'/'+m+'/'+y;
    }
    
    euroFormat( n ){
        // potrebbe arrivarmi : 
        //  37.767,91
        //  37767,91

        n = n.split('.').join(''); // togli i punti
        n = n.split(',').join('.'); // sostituisci virgola con i punti
        
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);
    }
    
    validateEmail(email) {
        // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    
    jsonCopy(src) {
        return JSON.parse(JSON.stringify(src));
    }
    
    setBoxInfoCliente(){
    
        let utente = sessione.get('datiutente');
        // console.log(utente);
        
        let ragsoc = '';
        let indirizzo = '';
        
        if( null !== utente && false !== utente){

            if( (null !== utente.RAGIONE_SOCIALE) && ('' !== utente.RAGIONE_SOCIALE) ) {
                ragsoc = utente.RAGIONE_SOCIALE;
            }
            else if( (null !== utente.COGNOME) && ('' !== utente.COGNOME) ) {
                ragsoc = utente.COGNOME + ' ' + utente.NOME;
            }

            if(  (null !== utente.ADDR) && ('' !== utente.ADDR) ) {
                indirizzo = utente.ADDR + ' '+utente.NUM_CIVICO + ', '+utente.NOME_COMUNE;
            }

            var el = document.getElementById('boxdettagliocliente');
            if(el){
                ReactDOM.render(<DettaglioCliente RAGSOC={ragsoc} INDIRIZZO={indirizzo} />, el ); 
            }
        }
    }
    
    pulisciBoxInfoCliente(){
        var el = document.getElementById('boxdettagliocliente');
        if(el){
            ReactDOM.render(<DettaglioCliente RAGSOC={''} INDIRIZZO={''} />, el ); 
        }
    }
    
    
    mostraBottoneAutolettureSoloUltimiGiorni(){
        let giorni = this.getObjInfoSocieta( 'ULTIMI_GIORNI_AUTOLETTURA' , 'NO' );
        
        if( giorni === 'NO') return true;
    
        let oggi = new Date();
        let primoGiornoUtile = new Date( oggi.getFullYear() , oggi.getMonth()+1, 1- parseInt(giorni , 10) );
        
        if( oggi.getTime() >= primoGiornoUtile.getTime() ) return true; else return false;
    }
    
    mostraBottoneAutoletturePerData(){
        let giorni = this.getObjInfoSocieta( 'GIORNI_NO_AUTOLETTURA' , 'NO' );
        
        if( giorni === 'NO') return true;
        
        let oggi = new Date();
        let ultimoGiornoUtile = new Date( oggi.getFullYear() , oggi.getMonth()+1, 1- parseInt(giorni , 10) );

        if( oggi.getTime() > ultimoGiornoUtile.getTime() ) return false; else return true;
    }
    
    mostraBottoneAutolettureDaDataAData()
    {
        let dadataadata = this.getObjInfoSocieta( 'AUTOLETTURA_DA_A' , '' );
        
        if( dadataadata === '' || dadataadata === false || dadataadata === null || dadataadata === 'null' ) return true;
        
        let pz = dadataadata.split('-');
        
        let dayA = parseInt(pz[0] , 10);
        let dayB = parseInt(pz[1] , 10);
        let addMonth=0;
        if( dayA > dayB ) addMonth = 1;
        
        let oggi = new Date();
        
        let primoGiornoUtile = new Date( oggi.getFullYear() , oggi.getMonth(), dayA , 0 , 0 , 0 );
        let ultimoGiornoUtile = new Date( oggi.getFullYear() , oggi.getMonth()+addMonth, dayB , 23 , 59 , 59);

        if( oggi.getTime() > ultimoGiornoUtile.getTime() ) return false;
        else if( oggi.getTime() < primoGiornoUtile.getTime() ) return false; 
        else return true;                                                                                                                
    }
    
    addScript(url){
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
    }
    
    addCss(url ,  cssId ){
        if (!document.getElementById(cssId))
        {
            var head  = document.getElementsByTagName('head')[0];
            var link  = document.createElement('link');
            link.id   = cssId;
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.href = url;
            link.media = 'all';
            head.appendChild(link);
        }
    }
    
}
export default Utils;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/Utils.js